import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ServiceBase } from 'services/servicebase';
import { DepartmentModel } from 'services/models/hiring/department.model';
import { HttpService } from "../http.service";

@Injectable()
export class DepartmentService extends ServiceBase<DepartmentModel> {
  constructor(http: HttpService) {
    super('department', http, environment.apiUrl);
  }

  createEntity(input: any): DepartmentModel {
    return DepartmentModel.create(input);
  }

}
